import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, PropTypes } from 'react';
import * as styles from './EllipsisLoader.scss';

var EllipsisLoader = /*#__PURE__*/function (_Component) {
  _inherits(EllipsisLoader, _Component);

  var _super = _createSuper(EllipsisLoader);

  function EllipsisLoader() {
    _classCallCheck(this, EllipsisLoader);

    return _super.apply(this, arguments);
  }

  _createClass(EllipsisLoader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: styles.saving,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("span", {
        style: this.props.spanStyle
      }, "."), /*#__PURE__*/React.createElement("span", {
        style: this.props.spanStyle
      }, "."), /*#__PURE__*/React.createElement("span", {
        style: this.props.spanStyle
      }, "."));
    }
  }]);

  return EllipsisLoader;
}(Component);

_defineProperty(EllipsisLoader, "defaultProps", {
  style: {},
  spanStyle: {}
});

export { EllipsisLoader as default };